var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4561 0C5.38136 0 0.456055 4.92531 0.456055 11C0.456055 17.0747 5.38136 22 11.4561 22C17.5307 22 22.4561 17.0747 22.4561 11C22.4561 4.92531 17.5307 0 11.4561 0ZM17.7418 11.7857H12.2418V17.2857H10.6703V11.7857H5.17034V10.2143H10.6703V4.71429H12.2418V10.2143H17.7418V11.7857Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AddCircle.188cd6b2.svg";
export { ForwardRef as ReactComponent };